const l = {
  name: "PlatformGrowth",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 39.7 40" style="enable-background:new 0 0 39.7 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M19.9,0l19.9,12l-8,4.9l-3,1.8l6.6,4l-11.1,6.7l6.6,4l-8,4.9L19.9,40L9,33.4l6.6-4L4.5,22.7l6.6-4L0,12
			L19.9,0z M19.9,29.7l1.9-1.1l0,0l9.7-5.9l-4.6-2.8l-6.9,4.2L13,19.9l-4.6,2.8l8.5,5.1l1.2,0.7L19.9,29.7z M17.5,30.6l-4.7,2.8
			l7,4.3l1.9-1.1l5.2-3.1l-4.7-2.8L19.9,32L17.5,30.6z M30.7,15.2l5.2-3.1l-16-9.7L3.9,12l16,9.7l6.6-4L30.7,15.2z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as PlatformGrowth
};
